import React, { Component } from 'react';
import { Text, View, FlatList, Button, ASButton, TimeStamp, Link, Confirm, WebBrowser, ActionSheet } from 'core';
import { Submission } from './group_submission';
import { getFileFromUploadsGroup } from 'selectors';
import { theme, css } from 'constants';
import * as actions from 'actions';
import { IcoTrash, IcoEdit, IcoDue, IcoDoc, IcoDownload, IcoFileType } from 'icons';
import { lang } from 'lang';

const keyExtractor = task => task.id;

const EmptyList = ({ is_admin }) => (
    <View style={{ margin: 20, marginTop: 100, alignItems: 'center' }}>
        {is_admin ? (
            <Text style={{ fontSize: theme.font_xl, marginBottom: 20, color: theme.gray_color_lighten(0.4) }}>{lang.NO_TASK_ADMIN}</Text>
        ) : (
            <Text style={{ fontSize: theme.font_xl, color: theme.gray_color_lighten(0.4) }}>{lang.NO_TASK_MEMBER}</Text>
        )}
    </View>
);

class Task extends Component {
    render() {
        const { is_admin, tasks } = this.props;
        const list_header = is_admin ? (
            <Button title={lang.ADD_TASK} color={theme.error_color_lighten(0.8)} style={styles.add_task} onPress={actions.clickAddTask} />
        ) : (
            <View style={{ height: 10 }} />
        );
        return (
            <FlatList
                data={tasks}
                keyExtractor={keyExtractor}
                ListHeaderComponent={list_header}
                renderItem={this._renderTaskItem}
                ListEmptyComponent={() => <EmptyList is_admin={is_admin} />}
            />
        );
    }

    _renderTaskItem = ({ item }) => {
        const { is_admin, conv_id, total_partic, submissions, submisions_uploads } = this.props;
        const { id, title, description, due, attachments, created, submit } = item;
        let options = [
            { icon: IcoEdit, text: lang.EDIT, onPress: () => actions.clickEditTask(id) },
            {
                icon: IcoTrash,
                text: lang.DELETE,
                onPress: () => Confirm(lang.CONFIRMA_REMOVE_ITEM(title), () => actions.sendRemoveTask({ group_id: conv_id, task_id: id }))
            }
        ];
        const crossed_deadline = item.due && item.due < Date.now();
        const line_cross = !is_admin && crossed_deadline;
        return (
            <View style={[styles.task_row, crossed_deadline && { backgroundColor: theme.gray_color_lighten(0.1) }]}>
                <View style={styles.task_container}>
                    <View style={styles.title_container}>
                        <View style={{ flex: 1 }}>
                            <Text style={[styles.title_text, line_cross && { textDecorationLine: 'line-through' }]}>{title}</Text>
                            {due ? (
                                <View style={styles.due}>
                                    <TimeStamp value={due} style={[styles.due_text, line_cross && { textDecorationLine: 'line-through' }]} only_date_time />
                                    <IcoDue style={styles.due_icon} size={16} />
                                </View>
                            ) : null}
                        </View>
                        {is_admin ? <ASButton options={options} style={styles.as} /> : null}
                    </View>
                    <Text style={[styles.description_text, line_cross && { textDecorationLine: 'line-through' }]}>{description}</Text>
                    {attachments ? <View style={styles.attachments_cont}>{attachments.map(this._renderAttachment)}</View> : null}
                    <TimeStamp value={created} style={styles.created} />
                </View>
                {submit ? (
                    <Submission
                        task={item}
                        upload={getFileFromUploadsGroup(submisions_uploads, item.id, item.id)}
                        conv_id={conv_id}
                        submission={submissions && submissions[item.id]}
                        crossed_deadline={crossed_deadline}
                        is_admin={is_admin}
                        total_partic={total_partic}
                    />
                ) : null}
            </View>
        );
    };

    _renderAttachment = (file, index) => {
        let attachment_options = [
            { icon: IcoDoc, text: lang.VIEW, onPress: () => WebBrowser.show(file) },
            { icon: IcoDownload, text: lang.DOWNLOAD, onPress: () => WebBrowser.download(file) }
        ];
        return (
            <Link
                style={styles.attachment}
                content_style={{ justifyContent: 'flex-start' }}
                onPress={event => ActionSheet.show({ options: attachment_options, event })}
                key={index}
            >
                <IcoFileType name={file.name} size={25} />
                <View style={{ flex: 1 }}>
                    <Text ellipsizeMode={'tail'} numberOfLines={1} style={{ color: theme.gray_color_lighten(0.6), paddingLeft: 3 }}>
                        {file.name}
                    </Text>
                </View>
            </Link>
        );
    };
}

const styles = css({
    add_task: {
        margin: 30,
        alignSelf: 'center'
    },
    task_row: {
        marginVertical: 4,
        marginHorizontal: 10,
        backgroundColor: theme.error_color_lighten(0.1),
        borderRadius: 10,
        overflow: 'hidden'
    },
    task_container: {
        padding: 20
    },
    title_container: {
        flexDirection: 'row',
        alignItems: 'flex-start'
    },
    as: {
        marginTop: -20,
        marginRight: -20
    },
    title_text: {
        color: theme.gray_color,
        fontSize: theme.font_xl,
        marginBottom: 10
    },
    due: {
        flex: 1,
        flexDirection: 'row',
        marginBottom: 10
    },
    due_icon: {
        color: theme.gray_color,
        marginLeft: 5
    },
    due_text: {
        fontSize: theme.font_md,
        color: theme.gray_color_lighten(0.7)
    },
    description_text: {
        fontSize: theme.font_md,
        color: theme.gray_color_lighten(0.6)
    },
    created: {
        marginTop: 10,
        alignSelf: 'flex-end',
        marginBottom: -10,
        marginRight: -10
    },

    submition: {
        height: 60,
        backgroundColor: theme.error_color_lighten(0.2),
        paddingHorizontal: 20,
        justifyContent: 'center'
    },
    attachments_cont: {
        marginTop: 20
    },
    attachment: {
        padding: 5,
        paddingVertical: 10,
        marginTop: 3,
        backgroundColor: theme.error_color_lighten(0.06),
        borderRadius: 10
    }
});

export default Task;



// WEBPACK FOOTER //
// ./src/components/right/group_task.js